module.exports = __webpack_public_path__ + "img/metro.dea1a340.svg";